import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  // Reindirizza automaticamente alla home dopo 10 secondi
  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      navigate("/");
    }, 10000);

    return () => clearTimeout(redirectTimer);
  }, [navigate]);

  return (
    <div className="container mx-auto px-4 py-16">
      <Helmet>
        <title>Pagina non trovata | ServiziClienti360.it</title>
        <meta
          name="description"
          content="La pagina che stai cercando non esiste o è stata spostata."
        />
      </Helmet>

      <div className="max-w-2xl mx-auto text-center">
        <div className="mb-8">
          <h1 className="text-8xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-3xl font-semibold text-gray-800 mb-2">
            Pagina non trovata
          </h2>
          <p className="text-gray-600 mb-8">
            La pagina che stai cercando non esiste o è stata spostata.
            Verrai reindirizzato automaticamente alla home page tra 10 secondi.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="bg-primary hover:bg-primary-dark text-white font-medium py-3 px-6 rounded-md transition-colors duration-300"
          >
            Torna alla Home
          </Link>
          <Link
            to="/contattaci"
            className="bg-white border border-primary text-primary hover:bg-gray-50 font-medium py-3 px-6 rounded-md transition-colors duration-300"
          >
            Contattaci
          </Link>
        </div>

        <div className="mt-12">
          <h3 className="text-xl font-medium text-gray-700 mb-4">
            Potresti essere interessato a:
          </h3>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/offerte"
              className="text-primary hover:text-primary-dark underline"
            >
              Le nostre offerte
            </Link>
            <Link
              to="/chi-siamo"
              className="text-primary hover:text-primary-dark underline"
            >
              Chi siamo
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 